import React, { useState } from 'react'
import {
  Wrapper,
  Icon,
  Title,
  MainParagraph,
  SecondaryParagraph,
  CloseButton,
  Link,
  IconCaret,
  LinkWrapper,
  ErrorParagraph,
  ErrorDetailWrapper,
} from './component.styles'

type ErrorWithStatus = {
  status?: number
  statusText?: string
  detail?: string
}

interface AddUserModalErrorProps {
  error: ErrorWithStatus
  onClose: () => void
}

const AddUserModalError: React.FC<AddUserModalErrorProps> = ({
  error,
  onClose,
}) => {
  const [showingDetails, setShowingDetails] = useState(false)

  const onPressLink = () => {
    setShowingDetails(prev => !prev)
  }

  return (
    <Wrapper data-testid="add-user-modal-wrapper">
      <Icon />
      <Title>We can't add users to the license right now</Title>
      <MainParagraph>
        There's been a server error. <br /> Wait a few minutes before trying
        again.
      </MainParagraph>
      <SecondaryParagraph>
        If you have questions, contact us: <br /> support@secondstep.org <br />
        800-634-4449, ext 1 or 206-343-1223
      </SecondaryParagraph>
      <CloseButton
        data-testid="add-user-modal-error-close-button"
        onClick={onClose}
      >
        Close
      </CloseButton>
      {error.status && (
        <React.Fragment>
          <LinkWrapper
            data-testid="add-user-modal-error-link"
            onClick={onPressLink}
            showingDetails={showingDetails}
          >
            <IconCaret showingDetails={showingDetails} />
            <Link>{showingDetails ? 'Hide' : 'Show'} Details</Link>
          </LinkWrapper>
          {showingDetails && (
            <ErrorDetailWrapper>
              <SecondaryParagraph data-testid="add-user-modal-error-code-text">
                Error code: {error.status} {error.statusText}
              </SecondaryParagraph>
              {error.detail && (
                <ErrorParagraph data-testid="add-user-modal-error-detail-text">
                  {error.detail}
                </ErrorParagraph>
              )}
            </ErrorDetailWrapper>
          )}
        </React.Fragment>
      )}
    </Wrapper>
  )
}

export default AddUserModalError
